module.exports = __webpack_public_path__ + "img/ic_group_order_shopping_bag_empty.df18e997.png";